import React from "react";
import { logo_white } from "../../../assets";

import { Link } from "react-router-dom";
import "./style.scss";
import { useWindowSize } from "../../../constants/useWindiwSize";
// import { PhoneIcon } from "../../../assets/Icons";

interface IProps {
  showTabs?: boolean;
  type?: number;
  onLoginClick?: () => void;
  isLoginShow?: boolean;
}

export default function Header({
  isLoginShow,
}: IProps) {

  const { isTablet } = useWindowSize();
  return (
    <header>
      <Link to="/">
        <img className="int-logo" src={logo_white as string} alt="Logo" />
      </Link>
      <div className="header-actions">
        {isLoginShow && !isTablet && (
          <>
            {/*<a href='tel:+37455756078' className='phone-info'>*/}
            {/*  <PhoneIcon />*/}
            {/*  <p className='phone-number'>+374 (55) 756078</p>*/}
            {/*</a>*/}
            <button className="login-button">
              <a href="https://dsp.intent.ai/auth/login">Login</a>
            </button>
          </>
        )}
        <a
          className="try-it"
          href=" https://meetings.hubspot.com/harut-martirosyan/product-demo-armenia"
          target="_blank"
          rel="noopener noreferrer"
        >
          Schedule a demo
        </a>
      </div>
    </header>
  );
}
